import React, { useEffect, useState } from "react";
import { Button, Dropdown, IconButton, Input, Menu, MenuButton, Modal, Option, Radio, RadioGroup, Sheet, Select, ModalDialog, Textarea, Checkbox } from '@mui/joy';
import { AddTaskBySyncApi } from "./function";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { postFetch } from "../../../../../fetch/fetch";

const NewKakaoChatRoomModalRegular: React.FC<any> = (props) => {

    const [description, setDescription] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {

        try{

            const result : any = await postFetch("/dashboard/todoist/addKakaoChatRoom", {
                title : description
            });

            if(result.message === "success") {
                toast.success("카카오톡 채팅방이 등록되었습니다.");
                setDescription("");
                props.handleClose();
            }

        }catch(e){
            console.error(e);
        }
    }


    return (
        <Modal open={props.open} onClose={() => {
            setDescription("");
            props.handleClose();
        }}>
            <ModalDialog>
                <div style={{
                    fontFamily: "Apple_B",
                    fontSize: "18px",
                    marginBottom: "24px"
                }}>
                    새로운 반복 카카오톡 채팅방 추가하기
                </div>

                <div>
                    <div>
                        <Textarea value={description} onChange={(e: any) => { setDescription(e.target.value) }} 
                            placeholder="카카오톡 채팅방 이름을 입력해주세요."
                        />
                    </div>
                </div>

                <div style={{
                    marginTop: "24px"
                }}>
                    <Button variant="solid" size="sm" fullWidth onClick={submit} loading={loading} disabled={!description}>
                        등록하기
                    </Button>
                </div>
            </ModalDialog>
        </Modal>
    )

}

export default NewKakaoChatRoomModalRegular;